import { useState, useEffect } from 'react';

import getConfig from '../../util/config';

const useGoogleRecaptcha = () => {
  const { google } = getConfig();
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [grecaptcha, setGrecaptcha] = useState(null);

  const loadGrecaptcha = () => {
    const { grecaptcha: intervalGrecaptcha } = global ?? {};

    if (intervalGrecaptcha && !grecaptcha) {
      setGrecaptcha(intervalGrecaptcha);
    }
  };

  useEffect(() => {
    setIntervalId(setInterval(loadGrecaptcha, 250));
  }, []);

  useEffect(() => {
    if (!recaptchaLoaded && grecaptcha) {
      grecaptcha?.enterprise?.ready(() => {
        setRecaptchaLoaded(true);
      });

      if (intervalId) {
        clearInterval(intervalId);
      }
    }
  }, [grecaptcha]);

  const onTokenRequest = async ({ action }) => {
    let token;
    if (recaptchaLoaded) {
      token = await grecaptcha.enterprise.execute(google.recaptchaSiteKey, {
        action,
      });
    }

    return token;
  };

  return {
    recaptchaLoaded,
    onTokenRequest,
  };
};

export default useGoogleRecaptcha;
